export default __webpack_public_path__ + "static/media/documents.9852326d.svg";